import api from './data.services'
import { authService } from './'

const alertSrv = 'alert'
const alertsPublicSrv = 'alert/public'
const alertColorsSrv = 'alertColor'
const alertStatusEnabledSrv = 'alert/enable'
const alertStatusDisabledSrv = 'alert/disable'
const alertDeletedSrv = 'alert/delete'


const getAlerts = async (filter: string = '', status: number = 0, page: number = 1) => {
  try {
    const resp: any = await api.getSrv(
        alertSrv,
        authService.getToken()
    )
    return {
      status: 'Ok',
      data: (resp && resp.data ? resp.data : [])
    }
  } catch(error) {
    return {
      status: 'Error',
      data: [],
      message: 'Error server al obtener alertas!'
    }
  }
}
const getAlertsPublic = async () => {
  try {
    const resp: any = await api.getSrv(
        alertsPublicSrv
    )
    return {
      status: 'Ok',
      data: (resp && resp.data ? resp.data : [])
    }
  } catch(error) {
    return {
      status: 'Error',
      data: [],
      message: 'Error server al obtener alertas!'
    }
  }
}

const getAlertById = async (alertId: number) => {
  try {
    const resp: any = await api.get(`${alertSrv}/${alertId}`, authService.getToken())

    return {
      status: 'Ok',
      data: (resp && resp.data ? resp.data : [])
    }
  } catch(error) {
    return {
      status: 'Error',
      data: {},
      message: 'Error server al obtener alerta!'
    }
  }
}

const getAlertStatus = async () => {
  try {
    const resp: any = await api.get(`${alertSrv}`, authService.getToken())

    return {
      status: 'Ok',
      data: (resp && resp.data && resp.data.statusData ? resp.data.statusData : [])
    }
  } catch(error) {
    return {
      status: 'Error',
      data: [],
      message: 'Error server al obtener estatus!'
    }
  }
}

const getAlertColors = async () => {
  try {
    const resp: any = await api.getSrv(`${alertColorsSrv}`, authService.getToken())
    return {
      status: 'Ok',
      data: (resp && resp.data ? resp.data : [])
    }
  } catch(error) {
    return {
      status: 'Error',
      data: [],
      message: 'Error server al obtener los colores!'
    }
  }
}

const getAlertColorById = async (colorId: number) => {
  try {
    const resp: any = await api.get(`${alertColorsSrv}/${colorId}`, authService.getToken())

    return {
      status: 'Ok',
      data: (resp && resp.data ? resp.data : [])
    }
  } catch(error) {
    return {
      status: 'Error',
      data: [],
      message: 'Error server al obtener el color!'
    }
  }
}

const registerAlert = async (alertData: any) => {
  try {
    const resp: any = await api.post(alertSrv, alertData, authService.getToken()).then(response => {
    }).catch(e => {
      console.log('alert error');
    });

    if(resp) {
      return {
        status: 'Ok',
        data: (resp && resp.data ? resp.data : [])
      }
    }

    return {
      status: 'Error',
      error: ''
    }
  } catch(error: any) {
    return {
      status: 'Error',
      statusCode: error?.statusCode,
      error,
      message: (error && error.statusCode === 400 ? error?.errors[0]?.msg : 'Error server al registar alerta!')
    }
  }
}

const updateAlert = async (userData: any, alertId: number) => {
  try {
    const resp: any = await api.put(`${alertSrv}/${alertId}`, userData, authService.getToken())
    if(resp) {
      return {
        status: 'Ok',
        data: (resp && resp.data ? resp.data : [])
      }
    }

    return {
      status: 'Error',
      error: ''
    }
  } catch(error: any) {
    return {
      status: 'Error',
      statusCode: error?.statusCode,
      error,
      message: (error && error.statusCode === 400 ? error?.errors[0]?.msg : 'Error server al actualizar alerta!')
    }
  }
}

const updateAlertStatus = async (id: number, status: boolean) => {
  try {
    let resp: any
    if(status) {
      resp = await api.put(`${alertStatusEnabledSrv}/${id}`, {}, authService.getToken())

    } else {
      resp = await api.put(`${alertStatusDisabledSrv}/${id}`, {}, authService.getToken())

    }
    return {
      status: 'Ok',
      data: (resp && resp.data ? resp.data : [])
    }
  } catch(error) {
    return {
      status: 'Error',
      data: [],
      message: 'Error server al habilitar o deshabilitar alerta!'
    }
  }
}

const deleteAlert = async (id: number) => {
  try {
    let resp: any = await api.del(alertDeletedSrv, id, authService.getToken())

    return {
      status: 'Ok',
      data: (resp && resp.data ? resp.data : [])
    }
  } catch(error) {
    return {
      status: 'Error',
      data: [],
      message: 'Error server al eliminar alerta!'
    }
  }
}

export const alertService = {
  getAlerts,
  getAlertsPublic,
  getAlertById,
  getAlertStatus,
  getAlertColors,
  getAlertColorById,
  registerAlert,
  updateAlert,
  updateAlertStatus,
  deleteAlert
}